import React, { useContext, useEffect, useState } from "react";
import { OperationContext } from "../../CreateOperation";
import { CustomTabs } from "../../../../../../common/components/Tabs/CustomTabs";
import { OperationConstant } from "../../../../core/_constant";
import { LandingContainerPointingList } from "./LandingContainerPointingList";
import { LandingBagPointingList } from "./LandingBagPointingList";
import { LandingVehiclePointingList } from "./LandingVehiclePointingList";
import { LandingCraftPointingList } from "./LandingCraftPointingList";
import { LandingOtherPointingList } from "./LandingOtherPointingList";

export const LandingPointingForm = () => {
  const { initialValue } = useContext(OperationContext);
  const [tabItems, setTabItems] = useState<Array<any>>([]);

  useEffect(() => {
    setTabItems(
      initialValue?.debarkationMovement?.loadPossessionStatus?.map(
        (item: any) => {
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: setComponents(item?.id),
          };
        }
      )
    );
  }, [initialValue]);

  const setComponents = (id: string) => {
    switch (id) {
      case OperationConstant.CONTAINER_ID:
        return <LandingContainerPointingList />;

      case OperationConstant.BAG_ID:
        return <LandingBagPointingList />;

      case OperationConstant.VEHICLE_ID:
        return <LandingVehiclePointingList />;

      case OperationConstant.CRAFT_ID:
        return <LandingCraftPointingList />;

      case OperationConstant.OTHER_ID:
        return <LandingOtherPointingList />;

      default:
        return <LandingContainerPointingList />;
    }
  };

  return (
    <>
      <CustomTabs items={tabItems} tabName="type" />
    </>
  );
};
